import * as React from "react";

import { UILocation } from "@1js/acui-common";
import { AppSliderProps } from "@1js/acui-slider";

import { RibbonSlider } from "../../Ribbon";

export function getDefaultRibbonSliderRenderer() {
  return (props: AppSliderProps) => (
    <RibbonSlider {...props} location={props.location || UILocation.Ribbon} />
  );
}
